export default "__VITE_ASSET__4363ccb6__"